import { BlueCityModule } from './blue-city.module';
import { platformBrowser } from '@angular/platform-browser';

platformBrowser()
    .bootstrapModule(BlueCityModule)
    .catch((err: unknown) => console.error(err));
